/**
 * Helper functions for asset permission management
 */

/**
 * Check if user can perform specific action based on role
 */
export const canUserPerformAction = (role: 'owner' | 'editor' | 'viewer' | null | undefined, action: 'read' | 'update' | 'delete' | 'share'): boolean => {
  if (!role) return false;

  switch (action) {
    case 'read':
      return true; // All roles can read
    case 'update':
      return role === 'owner' || role === 'editor';
    case 'delete':
    case 'share':
      return role === 'owner'; // Only owner can delete or share
    default:
      return false;
  }
};

/**
 * Get role display label
 */
export const getRoleLabel = (role: 'owner' | 'editor' | 'viewer' | null | undefined): string => {
  if (!role) return '';

  switch (role) {
    case 'owner': return 'Owner';
    case 'editor': return 'Editor';
    case 'viewer': return 'Viewer';
    default: return '';
  }
};

/**
 * Get role badge class for UI
 */
export const getRoleBadgeColor = (role: 'owner' | 'editor' | 'viewer' | null | undefined): string => {
  if (!role) return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100';

  switch (role) {
    case 'owner': return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-100';
    case 'editor': return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-800';
    case 'viewer': return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100';
  }
};